import { useEffect, useState } from "react";
import { Brain, Users } from "lucide-react";
import { api } from "../../lib/api";
import { STYLE_META } from "../../components/LearningStyleBadge";

export default function Dashboard() {
    const [data, setData] = useState(null);
    useEffect(() => {
        api.get("/dashboards/me").then((r) => setData(r.data));
    }, []);
    if (!data) return <div className="p-6 text-edu-muted">Cargando…</div>;
    const { user, stats } = data;
    const total = stats.total_students || 1;
    const styles = Object.entries(stats.by_style);

    return (
        <div className="p-6 md:p-10 fade-in" data-testid="psicologo-dashboard">
            <h1 className="text-3xl font-semibold mb-1">¡Bienvenido/a {user.name}! 👋</h1>
            <p className="text-edu-body mb-7">Resumen de los estudiantes a tu cargo.</p>

            <div className="grid md:grid-cols-2 gap-5 mb-8">
                <div className="edu-card p-6 flex items-center gap-4">
                    <div className="w-14 h-14 bg-edu-navy/10 rounded-xl flex items-center justify-center">
                        <Users size={26} className="text-edu-navy" />
                    </div>
                    <div>
                        <div className="text-xs uppercase tracking-widest text-edu-muted font-semibold">
                            Total Estudiantes
                        </div>
                        <div className="text-3xl font-bold">{stats.total_students}</div>
                    </div>
                </div>
                <div className="edu-card p-6 flex items-center gap-4">
                    <div className="w-14 h-14 bg-edu-gold/20 rounded-xl flex items-center justify-center">
                        <Brain size={26} className="text-edu-navy" />
                    </div>
                    <div>
                        <div className="text-xs uppercase tracking-widest text-edu-muted font-semibold">
                            Estilos Asignados
                        </div>
                        <div className="text-3xl font-bold">{stats.total_students - (stats.by_style["sin asignar"] || 0)}</div>
                    </div>
                </div>
            </div>

            <div className="edu-card p-6">
                <h3 className="text-lg font-semibold mb-4">Distribución por Estilo de Aprendizaje</h3>
                <div className="space-y-3">
                    {styles.map(([style, count]) => {
                        const meta = STYLE_META[style];
                        const pct = Math.round((count / total) * 100);
                        return (
                            <div key={style}>
                                <div className="flex items-center justify-between mb-1.5">
                                    <span className="text-sm font-medium capitalize">
                                        {meta?.label || style}
                                    </span>
                                    <span className="text-xs text-edu-muted">
                                        {count} ({pct}%)
                                    </span>
                                </div>
                                <div className="h-2.5 bg-gray-200 rounded-full overflow-hidden">
                                    <div
                                        className="h-full bg-edu-navy"
                                        style={{ width: `${pct}%` }}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
